import { CREATE_SERVICE, CREATE_SERVICE_SUCCESS, CREATE_SERVICE_ERROR, CREATE_SERVICE_EMPTY } from './../../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const CreateService = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_SERVICE:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CREATE_SERVICE_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case CREATE_SERVICE_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case CREATE_SERVICE_EMPTY:
      state = { ...initialState };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default CreateService;
